import type { JSX } from 'react'

import type { EntryMeta } from '../../types/sys'
import { Receipt } from '@components/receipt'
import { useReceipt } from '@graphql/hooks/receipt'
import { suspense } from '@lib/utils/suspense'

/**
 * A <Receipt> component that's hooked up to Contentful and fetches the type by id.
 */
const ReceiptInternal = suspense<Props & JSX.IntrinsicAttributes>(
    ({ sys: { id }, personalizations }) => {
        const { receipt, fetching } = useReceipt(id, personalizations)
        return <Receipt loading={fetching} items={receipt.items?.items ?? []} />
    },
)

export const renderContentfulReceipt = (props: Props) => (
    <ReceiptInternal {...props} />
)

export default ReceiptInternal

interface Props extends EntryMeta {
    personalizations?: Record<string, any>
}
